import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { ListTgadvisoryUserComponent } from './list-tgadvisory-user/list-tgadvisory-user.component';

const routes: Routes = [
  {
    path: '',
    component: ListTgadvisoryUserComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TgadvisoryUserRoutingModule { }
